import { render, staticRenderFns } from "./projectCosts.vue?vue&type=template&id=73f35441&scoped=true&"
import script from "./projectCosts.vue?vue&type=script&lang=js&"
export * from "./projectCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f35441",
  null
  
)

export default component.exports